import { Image, isEditorActive, Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import ReplaceableText from '../../../utils/text/ReplaceableText/index';
import { connect } from 'react-redux';

const InterstitialPage = ({ rendering, fields, show }) => {
  if (!show && !isEditorActive()) {
    return null;
  }
  const imageClass = 'vds-wide-card__image-container vds-wide-card__image-container--medium';
  const renderImage = () => {
    if (isEditorActive()) {
      return <Image className={imageClass} field={fields.image} />;
    }
    return (
      <div
        className={imageClass}
        style={{ background: `url('${fields.image?.value?.src}')`, backgroundSize: 'cover' }}
      />
    );
  };

  return (
    <div className="vds-interstitial-page">
      <div className="vds-interstitial-page__inner">
        <div className="vds-interstitial-page__main">
          <div className="vds-interstitial-page__inner">
            <header className="vds-interstitial-page__header">
              <div className="vds-interstitial-page__header-logo-container" />
            </header>

            <main className="vds-interstitial-page__main">
              <div className="vds-wide-card vds-wide-card--stacked">
                {renderImage()}
                <div className="vds-wide-card__text-container">
                  <div className="vds-wide-card__text">
                    <ReplaceableText
                      tag="h2"
                      className="vds-wide-card__heading"
                      field={fields.text}
                    />
                  </div>
                </div>
              </div>
            </main>
          </div>
          <Placeholder
            name="interstitial-logic"
            rendering={rendering}
            minDisplayTime={fields.minDisplayTime?.value}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const trigger = props.fields.trigger?.value;
  let show = false;
  if (trigger) {
    show = state.appState?.overlay?.type === trigger;
  }
  return {
    ...props,
    show,
  };
};
export default connect(mapStateToProps)(InterstitialPage);
